import React from 'react';
import { luxuryExperiences } from '@/data/romaniaHub';
import { Clock, Award, ArrowRight } from 'lucide-react';

interface Props {
  onInquire: () => void;
}

const LuxuryExperiences: React.FC<Props> = ({ onInquire }) => {
  return (
    <section id="experiences" className="py-24 lg:py-32 bg-[#1A3B5C] text-white">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">
              Curated Collections
            </span>
            <div className="w-12 h-[1px] bg-[#C9A961]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light mb-6">
            Luxury Experiences
          </h2>
          <p className="font-sans text-sm text-white/60 max-w-2xl mx-auto leading-relaxed">
            More than itineraries — these are curated journeys, each composed around a single
            unforgettable theme and tailored entirely to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {luxuryExperiences.map((exp) => (
            <article
              key={exp.id}
              className="group bg-white/5 border border-white/10 hover:border-[#C9A961]/50 transition-all duration-500 overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={exp.image}
                  alt={exp.imageAlt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-[#C9A961] text-white px-3 py-1.5 font-sans text-[9px] tracking-[0.2em] uppercase flex items-center gap-1.5">
                  <Award className="w-3 h-3" /> {exp.level}
                </div>
              </div>

              <div className="p-7 flex flex-col flex-1">
                <h3 className="font-serif text-2xl font-light mb-4 group-hover:text-[#C9A961] transition-colors">
                  {exp.title}
                </h3>
                <p className="font-sans text-xs text-white/60 leading-relaxed mb-5">
                  {exp.description}
                </p>

                <ul className="space-y-1.5 mb-6">
                  {exp.highlights.map((h) => (
                    <li key={h} className="font-sans text-[11px] text-white/70 flex items-center gap-2">
                      <span className="w-1 h-1 bg-[#C9A961] rounded-full" /> {h}
                    </li>
                  ))}
                </ul>

                <div className="mt-auto pt-5 border-t border-white/10 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 font-sans text-[10px] tracking-wider uppercase text-white/50">
                    <Clock className="w-3.5 h-3.5 text-[#C9A961]" /> {exp.duration}
                  </span>
                  <button
                    onClick={onInquire}
                    className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#C9A961] flex items-center gap-2 hover:gap-3 transition-all"
                  >
                    Inquire <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LuxuryExperiences;
